import ExampleCodeBlock, {
  CodeParamType,
} from 'components/Docs/ExampleCodeBlock'

import { httpCodeExamples } from '../http-code-examples'

const js = `await integrationApp
  .connection('{INTEGRATION_KEY}')
  .dataSource('{DATA_SOURCE_KEY}')
  .patch('{INPUT}')
`
const rest = httpCodeExamples(
  '/connections/{INTEGRATION_KEY}/data-sources/{DATA_SOURCE_KEY}',
  {
    method: 'PATCH',
    body: '{INPUT}',
  },
)

export function PatchDataSourceInstanceCodeExample() {
  return (
    <ExampleCodeBlock
      customCodes={{ js, ...rest }}
      parameters={{
        INTEGRATION_KEY: CodeParamType.IntegrationKey,
        DATA_SOURCE_KEY: CodeParamType.DataSourceKey,
        INPUT: CodeParamType.Object,
      }}
      run={async ({ integrationApp, parameters }) => {
        return await integrationApp
          .connection(parameters.INTEGRATION_KEY)
          .dataSource(parameters.DATA_SOURCE_KEY)
          .patch(parameters.INPUT)
      }}
    />
  )
}
